import React from 'react';
import { useAnalytics, useLanguage } from '../../components';
import { LANGUAGES, isLanguageCode } from '../../languages';
export function LanguageSelect({ selectLanguageLabel }) {
    const currentLanguage = useLanguage();
    const { sendTrackEvent } = useAnalytics();
    return (React.createElement("select", { "aria-label": selectLanguageLabel !== null && selectLanguageLabel !== void 0 ? selectLanguageLabel : 'Select a language', value: currentLanguage, onChange: ({ target }) => {
            const { value: selectedLanguage } = target;
            const segments = location.pathname.split('/').slice(1);
            sendTrackEvent('selectedLanguage', {
                event: 'selected',
                eventComponent: `${selectedLanguage}Option`,
                eventContainer: 'languageSelect',
                label: `${selectedLanguage} language`,
                uuid: `${selectedLanguage}_language`
            });
            if (isLanguageCode(segments[0])) {
                location.href = `/${selectedLanguage}/${segments.slice(1).join('/')}`;
            }
            else {
                location.href = `/${selectedLanguage}/${segments.join('/')}`;
            }
        }, "data-testid": "language-select" }, LANGUAGES.map(({ code, name }) => (React.createElement("option", { key: code, value: code, "data-uuid": `${code}_language` }, name)))));
}
//# sourceMappingURL=LanguageSelect.js.map